import {memo} from 'react';
import {styled} from 'styled-components';
import {forbidExtraProps} from 'airbnb-prop-types';
import {oneOf, array, number, func} from 'prop-types';
import {bgAccentMain, button14, bgAccentTabs, btnSecondaryNormalBorder, textPrimary} from 'r/Design';
import {useStateReducer} from 'r/utils';

const Wr = styled.div`
  color: ${textPrimary};
  ${button14}
  display: flex;
  align-items: center;
  `;

const Select = styled.select`
  color: ${textPrimary};
  border: 1px solid ${btnSecondaryNormalBorder};
  background: ${bgAccentMain};
  height: 28px;
  width: 28px;
  cursor: pointer;
  border-radius: 4px;
  appearance: none;
  text-align-last: center;
  outline: none;
  option {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &:hover {
    background: ${bgAccentTabs};
  }
`;

const Input = styled.input`
  border: 1px solid ${btnSecondaryNormalBorder};
  height: 28px;
  width: 28px;

  border-radius: 4px;
  appearance: none;
  text-align-last: center;
  outline: none;
`;


let timeoutId;

export default memo(PageLength);

PageLength.propTypes = forbidExtraProps({
  onSelect: func.isRequired,
  value: number.isRequired,
  options: array,
  text: array,
  type: oneOf(['input', 'select']),
});

function PageLength({
  value,
  onSelect,
  options = [10, 50, 100],
  text = ['Show ', ' records'],
  type = 'select',
}) {
  const [{
    _value,
  }, ss] = useStateReducer({
    _value: value,
  });

  const handleInputChange = value => {
    clearInterval(timeoutId);
    if (value === '') {
      ss({_value: value});
      return;
    }
    if (!value.match(/^[0-9]+$/)) {
      return;
    }
    if (Number(value) > 999) {
      return;
    }
    else {
      ss({_value: value});
      timeoutId = setTimeout(
        () => {
          onSelect(Number(value));
        },
        1_000,
      );
    }
  };

  return (
    <Wr>
      {text[0]}&nbsp;
      {type === 'select'
        ? (
          <Select onChange={({target: {value}}) => onSelect(Number(value))} value={value}>
            {options.map(value => (
              <option key={value} value={value}>{value}</option>
            ))}
          </Select>
        )
        : <Input onChange={({target: {value}}) => handleInputChange(value)} value={_value}/>
      }
      &nbsp;{text[1]}
    </Wr>
  );
}
